export default "__VITE_ASSET__CTkQkYpT__"